import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["allowDecimals", "max", "min"];
import React, { useState, useEffect } from 'react';
import { bool, number } from 'prop-types';
import MaskedInput from '../masked-input/MaskedInput';
const createMaskOptions = function ({
  allowDecimals,
  max,
  min
}) {
  return {
    max,
    min,
    mask: Number,
    padFractionalZeros: allowDecimals,
    radix: '.',
    scale: allowDecimals ? 2 : 0,
    thousandsSeparator: ','
  };
};
const adornmentStyles = {
  pointerEvents: 'none'
};
function CurrencyInput(props) {
  const {
      allowDecimals,
      max,
      min
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded);
  const [maskOptions, setMaskOptions] = useState(function () {
    return createMaskOptions({
      allowDecimals,
      max,
      min
    });
  });
  useEffect(function () {
    setMaskOptions(createMaskOptions({
      allowDecimals,
      max,
      min
    }));
  }, [allowDecimals, max, min]);
  return /*#__PURE__*/React.createElement(MaskedInput, Object.assign({}, otherProps, {
    inputMode: "decimal",
    startAdornment: /*#__PURE__*/React.createElement("span", {
      style: adornmentStyles
    }, "$"),
    maskOptions: maskOptions
  }));
}
CurrencyInput.defaultProps = {
  allowDecimals: false
};
CurrencyInput.propTypes = {
  /**
   * If `true` the user will be able to enter decimals as part of the value
   * and in case no decimals are entered by default a .00 will be appended
   * when the focus is lost.
   *
   *  If `false` only the integer part can be entered.
   */
  allowDecimals: bool,
  /**
   * The maximum value that can be entered into the Input.
   */
  max: number,
  /**
   * The minimum value that can be entered into the Input.
   *
   * It __must be a positive number__, it does not accept negatives.
   */
  min: number
};
export default CurrencyInput;